<template>
  <div>
    <div class="row mb-4 px-0 b-form__row_type_flex-end">
      <div class="col-8">
        <cool-select :list="counterparties"
                     option-value="id"
                     option-text="value"
                     :isError="isError"
                     :placeholder="$t('CONTENT.choose')"
                     v-model="currentLessor"></cool-select>
      </div>
      <div class="b-contract__check mx-2 mb-2" v-if="checkIsCounterpartyIntragroup">
        <dynamic-icon class="mr-2" icon="check"></dynamic-icon>
        {{$t('CONTENT.counterparty.VGO')}}
      </div>
      <button type="button" class="b-btn b-btn_border_none" @click="deleteLessorItem" v-if="lessorsLength > 1">
        <dynamic-icon class="b-btn__icon" icon="close"></dynamic-icon>
      </button>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    props: {
      lessorIndex: {
        type: Number,
      },
      lessor: {
        type: Number,
      },
      lessorsLength: {
        type: Number,
      },
      isError: {
        type: Boolean,
      }
    },
    created() {
      this.currentLessorFromProps = this.lessor;
    },
    data() {
      return {
        isAutoBindDataLessor: false,
        currentLessorFromProps: null,
      }
    },
    computed: {
      ...mapGetters(['getCounterpartiresForContract']),
      ...mapGetters(['allCounterparties']),
      counterparties() {
        return this.getCounterpartiresForContract;
      },
      checkIsCounterpartyIntragroup: {
        get() {
          if(this.currentLessorFromProps === null) {
            return false;
          } else {
            return this.checkIsCounterpartyIntragroupFn(this.currentLessorFromProps);
          }
        },
        set(newVal) {
          this.currentLessorFromProps = +newVal;
        }
      },
      currentLessor: {
        get() {
          const neededCounterParty = this.counterparties.find(c => c.id === this.currentLessorFromProps);
          if(neededCounterParty === undefined) {
            console.warn(`Cannot find counterparty with id ${this.currentLessorFromProps}. Maybe it was deleted...`);
            return null;
          }
          return this.currentLessorFromProps;
        },
        set(newVal) {
          this.currentLessorFromProps = newVal;
          this.$emit('selectLessor', {index: this.lessorIndex, value: newVal});
        }
      }
    },
    methods: {
      deleteLessorItem() {
        this.$emit('deleteLessor', this.lessorIndex);
        this.currentLessorFromProps = this.lessor;
      },
      checkIsCounterpartyIntragroupFn(id) {
        for (let i = 0; i < this.allCounterparties.length; i++) {
          if (this.allCounterparties[i].idInDB === id) {
            return this.allCounterparties[i].isIntragroupTurnover;
          }
        }
      },
    }
  }
</script>
